import type React from 'react';

/**
 * Parses a text string containing markdown-style links [text](url)
 * and returns React elements with actual <a> tags for each link.
 * Plain text segments are preserved as-is.
 */
export function renderLinkedText(text: string | undefined): React.ReactNode {
  if (!text) return null;

  const linkPattern = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkPattern.exec(text)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    // Add the link as an <a> element
    const [, linkText, url] = match;
    parts.push(
      <a
        key={`${match.index}-${url}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </a>,
    );

    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after the last link
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  // If no links found, return the original text
  if (parts.length === 0) return text;

  return <>{parts}</>;
}
